import React from 'react';
import {Collaboration, Card} from 'components';
import {openPopup, useNamedSelector} from 'helpers';
import {role} from 'store/relations';

export function CardStatus({ id, selector }) {
  const [ context ] = selector.split('.');
  const { collaboration } = useNamedSelector(selector, { id, context });
  return collaboration?.self.type && (
    <Card.Status
      aria-haspopup
      className={[/Collaborate/.test(collaboration.self.type) && 'blue', collaboration.self.type == 'Owner' && 'orange']}
      children={role(collaboration.self)}
      onClick={openPopup(Collaboration.ShareMenuMinimum, {id, context})}
    />
  );
}
